var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconZoomIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69531 13.1406C7.9375 13.1406 9.10156 12.7656 10.0703 12.125L13.4922 15.5547C13.7188 15.7734 14.0078 15.8828 14.3203 15.8828C14.9688 15.8828 15.4453 15.375 15.4453 14.7344C15.4453 14.4375 15.3438 14.1484 15.125 13.9297L11.7266 10.5156C12.4297 9.51562 12.8438 8.30469 12.8438 6.99219C12.8438 3.60938 10.0781 0.84375 6.69531 0.84375C3.32031 0.84375 0.546875 3.60938 0.546875 6.99219C0.546875 10.375 3.3125 13.1406 6.69531 13.1406ZM6.69531 11.5C4.21875 11.5 2.1875 9.46875 2.1875 6.99219C2.1875 4.51562 4.21875 2.48438 6.69531 2.48438C9.17188 2.48438 11.2031 4.51562 11.2031 6.99219C11.2031 9.46875 9.17188 11.5 6.69531 11.5ZM6.69531 9.70312C7.05469 9.70312 7.33594 9.42969 7.33594 9.08594V7.60156H8.71094C9.03906 7.60156 9.32812 7.32031 9.32812 6.99219C9.32812 6.65625 9.03906 6.375 8.71094 6.375H7.33594V4.89844C7.33594 4.54688 7.0625 4.28906 6.69531 4.28906C6.33594 4.28906 6.05469 4.54688 6.05469 4.89844V6.375H4.67969C4.35156 6.375 4.0625 6.66406 4.0625 6.99219C4.07031 7.32031 4.35156 7.60156 4.67969 7.60156H6.05469V9.08594C6.05469 9.42969 6.34375 9.70312 6.69531 9.70312Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconZoomIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-zoom-in.a30854178569e235a35ad6177f4af02d.svg";